/** Figma title-block → asset gaps for bottom-row homepage terms cards (px). */
export const TERMS_TITLE_ASSET_GAP = {
  /** Equity + guarantees lede cards (Figma 5948:28607 / 6142:29364). */
  lede: "mt-[43px] lg:mt-10",
  /** Spend chips card (Figma 5948:28542). */
  spend: "mt-[30px] lg:mt-[39px]",
} as const;

/** Top-row card height — pricing + repayment (Figma 6055:30126 / 6055:30149). */
export const TERMS_TOP_ROW_CARD_HEIGHT = "h-[404px] lg:h-[471px]";

/** Bottom-row card height (Figma 6055:30123). */
export const TERMS_BOTTOM_CARD_HEIGHT = "h-[280px] lg:h-[280px]";

/** Bottom-row card inset — 24px mobile, 32px desktop (Figma 5948:28542). */
export const TERMS_BOTTOM_CARD_PADDING = "p-6 lg:p-8";

/** Title inset only — bottom-row Rive bands extend to card bottom (Figma 6142:29364). */
export const TERMS_BOTTOM_CARD_TITLE_PADDING = "px-6 pt-6 lg:px-8 lg:pt-8";

/** Equity Rive band — tall enough for 3-bar stack, horizontal inset (Figma 6142:29367). */
export const TERMS_EQUITY_RIVE_ASSET_BAND =
  "absolute inset-x-6 bottom-0 h-[204px] lg:inset-x-8 lg:h-[214px]";

/** Guarantees Rive band — glass UI + glows, bleeds right (Figma 6142:29472). */
export const TERMS_GUARANTEES_RIVE_ASSET_BAND =
  "absolute bottom-0 left-6 right-0 h-[204px] lg:left-8 lg:h-[214px]";

/** Minimum acceptable gap between title bottom and asset top (px). */
export const TERMS_MIN_TITLE_ASSET_GAP = {
  lede: 32,
  spend: 24,
} as const;
